
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homeJiOV61qlhjHJfb1O3Tdhvc3KJt5VbwZsBsTifqhlGoUMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/home.vue?macro=true";
import { default as errorYAtY32G6BjJXbl9iz0oTb_34Qro8cBD7BBUS6bDUAHoMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/error.vue?macro=true";
import { default as index9S0HpquhqZv49cxCo6mnfIan5ys40fXiR0wnCuGjcZcMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/index.vue?macro=true";
import { default as loginK1bvi26TP1zChhaspiMbYJqlwaPpb6WrY0ZWmBiH1TAMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/login.vue?macro=true";
import { default as allTagWOJscPW9cmlT3MuOFrgXuOrEArlwi_aAiL9V1oAO7cAMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/allTag.vue?macro=true";
import { default as hotTagnCP6g98qSew8v0ORGTe4GwV_9veQ_wgZB10DLCifj94Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/hotTag.vue?macro=true";
import { default as launchiiCs7FnnVgxpdo5FaEFWGfhT71rvesp70H0pURlJ7PIMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/launch.vue?macro=true";
import { default as bestFilm7CwZLO4bX2WASMOEr2gMbR_1y0tdvjLW5r6AHysFkOAMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/bestFilm.vue?macro=true";
import { default as feedBackqO1ZDu5jhbf_45BIfrHkb5qTuaERXyQqlkgpjmGwI_45UioMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/feedBack.vue?macro=true";
import { default as registerYsWKBw9XWtjZWoP7UM_CgoKBrhrq1xnj1cFvn2MetqkMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/register.vue?macro=true";
import { default as replyListE6Fgc7f4N6dsnP_cy1P0aYJU7ISOX0_45rxwF7J5MnB_450Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/replyList.vue?macro=true";
import { default as videoPage5uRiE8cF5ogdQ8liY6cgl0jpnlesc3uLn_GRGCTtnkoMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/videoPage.vue?macro=true";
import { default as demoPlayerxoHfxjgkllQ9rJ7T33Cnqax6rIwoR2lt65xEsYOcOs8Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/demoPlayer.vue?macro=true";
import { default as homeDefaultQ46BrxxjAyKwP5a2obizCs6wEq0nuXh1JoN1fm3bpCgMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/homeDefault.vue?macro=true";
import { default as hotChannelsnZQZhEEMrvKCiP9LSFvcP2UAhWpj2VJatdp_j7Y7_45GUMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/hotChannels.vue?macro=true";
import { default as swiperVideoQ2pQsAS9lOUZBKtwuCwOqiIdPpK4yJiUCRneEHnt6ZMMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/swiperVideo.vue?macro=true";
import { default as videoDetailES2_45D9E_mps04ycwL8_45DD5QtEoH2DfQz4G28PvFisyEMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/videoDetail.vue?macro=true";
import { default as videoPage_451z0M_RyrsFypErCBJ7FUNF_45X3_45iIr3Fjtpj2_45r5HZRZQMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/videoPage-1.vue?macro=true";
import { default as newRecommendSaGqIMrBK_45ye2cfOjoBMN8amhVtjtZHbzU1g5qcMWTUMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/newRecommend.vue?macro=true";
import { default as index_456lS25YClYQRI8qQN3XmYcCg_dlUk_jNdNFLb4GMEvsMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/search/index.vue?macro=true";
import { default as collectFngtTq9bpzVwEv3EVqcioaEenHytNK6H2UHTg9XM8x4Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/collect.vue?macro=true";
import { default as bindPhone0fI9uaicKCL9ysjkw6htZpZ2zmXUdDH0Bbl3633f4CoMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/bindPhone.vue?macro=true";
import { default as hotTagy6sxfuiOh3P32SeHYvZRanCVNeozQ4vYPACzRs8SjxIMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/hotTag.vue?macro=true";
import { default as watchRecord2SQOqe1vXWdHLFbqq4lkYsxSrbWCuOth3iz6aIkqUYEMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/watchRecord.vue?macro=true";
import { default as movieHotPyBNZyfG4PMOm2DHVq5Wg_45iru5PYy0VdZZTPDLr9JFwMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieHot.vue?macro=true";
import { default as movieBestIvdKilsI3twL1c5YSgp9YWFGsCNB3BUUAl84U9Ptnv0Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieBest.vue?macro=true";
import { default as resetPasswordn5lVtan_45Pqo6G1fwDktHkocoU6YDhBM7rIrDKMi9hckMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/resetPassword.vue?macro=true";
import { default as sentry_45example_45pageMWe4QjWNQ1Ler84yvDAAoeIV4CKiGY1oNR2LYiYKsS0Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/sentry-example-page.vue?macro=true";
import { default as movieStoreviijJ97tOFVW_45cj3b82xd2YMQMJm_45zn_7UPEP7fu6WoMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieStore.vue?macro=true";
import { default as movieLatestR8yHSs7pzi5STDWMYKsLVqJapdZE_453xdJZXaE8BVvRQMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieLatest.vue?macro=true";
import { default as movieRecordBjxlWk2AyzOrav2DcMk_45LzW_pKYyX9zGNAu3X0q2zJsMeta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieRecord.vue?macro=true";
import { default as searchGayLayerk2dQZejskyffsERDlxOOx68iLr_claTVs_45l5ditSXE4Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/search/components/searchGayLayer.vue?macro=true";
import { default as searchResultListi4R5mCRP7G9sMyJKb8F9awmwvzQnrInzxzf5D7q33l4Meta } from "/Users/kevin/jenkins/git/media/player-client-gay/pages/search/components/searchResultList.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/home.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginK1bvi26TP1zChhaspiMbYJqlwaPpb6WrY0ZWmBiH1TAMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/login.vue")
  },
  {
    name: "allTag",
    path: "/allTag",
    meta: { ...(allTagWOJscPW9cmlT3MuOFrgXuOrEArlwi_aAiL9V1oAO7cAMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/allTag.vue")
  },
  {
    name: "hotTag",
    path: "/hotTag",
    meta: { ...(hotTagnCP6g98qSew8v0ORGTe4GwV_9veQ_wgZB10DLCifj94Meta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/hotTag.vue")
  },
  {
    name: "launch",
    path: "/launch",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/launch.vue")
  },
  {
    name: "bestFilm",
    path: "/bestFilm",
    meta: { ...(bestFilm7CwZLO4bX2WASMOEr2gMbR_1y0tdvjLW5r6AHysFkOAMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/bestFilm.vue")
  },
  {
    name: "feedBack",
    path: "/feedBack",
    meta: { ...(feedBackqO1ZDu5jhbf_45BIfrHkb5qTuaERXyQqlkgpjmGwI_45UioMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/feedBack.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: { ...(registerYsWKBw9XWtjZWoP7UM_CgoKBrhrq1xnj1cFvn2MetqkMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/register.vue")
  },
  {
    name: "replyList",
    path: "/replyList",
    meta: { ...(replyListE6Fgc7f4N6dsnP_cy1P0aYJU7ISOX0_45rxwF7J5MnB_450Meta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/replyList.vue")
  },
  {
    name: "videoPage",
    path: "/videoPage",
    meta: { ...(videoPage5uRiE8cF5ogdQ8liY6cgl0jpnlesc3uLn_GRGCTtnkoMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/videoPage.vue")
  },
  {
    name: "demoPlayer",
    path: "/demoPlayer",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/demoPlayer.vue")
  },
  {
    name: "homeDefault",
    path: "/homeDefault",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/homeDefault.vue")
  },
  {
    name: "hotChannels",
    path: "/hotChannels",
    meta: { ...(hotChannelsnZQZhEEMrvKCiP9LSFvcP2UAhWpj2VJatdp_j7Y7_45GUMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/hotChannels.vue")
  },
  {
    name: "swiperVideo",
    path: "/swiperVideo",
    meta: { ...(swiperVideoQ2pQsAS9lOUZBKtwuCwOqiIdPpK4yJiUCRneEHnt6ZMMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/swiperVideo.vue")
  },
  {
    name: "videoDetail",
    path: "/videoDetail",
    meta: { ...(videoDetailES2_45D9E_mps04ycwL8_45DD5QtEoH2DfQz4G28PvFisyEMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/videoDetail.vue")
  },
  {
    name: "videoPage-1",
    path: "/videoPage-1",
    meta: { ...(videoPage_451z0M_RyrsFypErCBJ7FUNF_45X3_45iIr3Fjtpj2_45r5HZRZQMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/videoPage-1.vue")
  },
  {
    name: "newRecommend",
    path: "/newRecommend",
    meta: { ...(newRecommendSaGqIMrBK_45ye2cfOjoBMN8amhVtjtZHbzU1g5qcMWTUMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/newRecommend.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: { ...(index_456lS25YClYQRI8qQN3XmYcCg_dlUk_jNdNFLb4GMEvsMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/search/index.vue")
  },
  {
    name: "user-collect",
    path: "/user/collect",
    meta: { ...(collectFngtTq9bpzVwEv3EVqcioaEenHytNK6H2UHTg9XM8x4Meta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/collect.vue")
  },
  {
    name: "user-bindPhone",
    path: "/user/bindPhone",
    meta: { ...(bindPhone0fI9uaicKCL9ysjkw6htZpZ2zmXUdDH0Bbl3633f4CoMeta || {}), ...{"middleware":["auth","check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/bindPhone.vue")
  },
  {
    name: "user-gay-hotTag",
    path: "/user/gay/hotTag",
    meta: { ...(hotTagy6sxfuiOh3P32SeHYvZRanCVNeozQ4vYPACzRs8SjxIMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/hotTag.vue")
  },
  {
    name: "user-watchRecord",
    path: "/user/watchRecord",
    meta: { ...(watchRecord2SQOqe1vXWdHLFbqq4lkYsxSrbWCuOth3iz6aIkqUYEMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/watchRecord.vue")
  },
  {
    name: "user-gay-movieHot",
    path: "/user/gay/movieHot",
    meta: { ...(movieHotPyBNZyfG4PMOm2DHVq5Wg_45iru5PYy0VdZZTPDLr9JFwMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieHot.vue")
  },
  {
    name: "user-gay-movieBest",
    path: "/user/gay/movieBest",
    meta: { ...(movieBestIvdKilsI3twL1c5YSgp9YWFGsCNB3BUUAl84U9Ptnv0Meta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieBest.vue")
  },
  {
    name: "user-resetPassword",
    path: "/user/resetPassword",
    meta: { ...(resetPasswordn5lVtan_45Pqo6G1fwDktHkocoU6YDhBM7rIrDKMi9hckMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/resetPassword.vue")
  },
  {
    name: "sentry-example-page",
    path: "/sentry-example-page",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/sentry-example-page.vue")
  },
  {
    name: "user-gay-movieStore",
    path: "/user/gay/movieStore",
    meta: { ...(movieStoreviijJ97tOFVW_45cj3b82xd2YMQMJm_45zn_7UPEP7fu6WoMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieStore.vue")
  },
  {
    name: "user-gay-movieLatest",
    path: "/user/gay/movieLatest",
    meta: { ...(movieLatestR8yHSs7pzi5STDWMYKsLVqJapdZE_453xdJZXaE8BVvRQMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieLatest.vue")
  },
  {
    name: "user-gay-movieRecord",
    path: "/user/gay/movieRecord",
    meta: { ...(movieRecordBjxlWk2AyzOrav2DcMk_45LzW_pKYyX9zGNAu3X0q2zJsMeta || {}), ...{"middleware":["check-app-config"]} },
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/user/gay/movieRecord.vue")
  },
  {
    name: "search-components-searchGayLayer",
    path: "/search/components/searchGayLayer",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/search/components/searchGayLayer.vue")
  },
  {
    name: "search-components-searchResultList",
    path: "/search/components/searchResultList",
    component: () => import("/Users/kevin/jenkins/git/media/player-client-gay/pages/search/components/searchResultList.vue")
  }
]